document.addEventListener("turbo:load", function () {
  var form = document.querySelector("[data-job-filter-form]");
  if (!form || form.dataset.filterBound) return;
  form.dataset.filterBound = "true";

  var searchInput = form.querySelector("[data-search-input]");
  var clearBtn = form.querySelector("[data-clear-filters]");

  form.addEventListener("change", function (event) {
    if (searchInput && event.target === searchInput) return;
    updateUrl();
    submitForm(form);
  });

  if (searchInput) {
    var timeout;
    searchInput.addEventListener("input", function () {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        updateUrl();
        submitForm(form);
      }, 300);
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      clearFilters();
      history.pushState({}, "", form.action);
      submitForm(form);
    });
  }

  function clearFilters() {
    if (searchInput) searchInput.value = "";

    form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => checkbox.checked = false);

    var radioGroups = {};
    var radios = form.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      radioGroups[radios[i].name] = true;
    }

    var groupNames = Object.keys(radioGroups);
    for (var j = 0; j < groupNames.length; j++) {
      var blankOption = form.querySelector(
        'input[type="radio"][name="' + groupNames[j] + '"][value=""]'
      );
      if (blankOption) {
        blankOption.checked = true;
      }
    }
  }

  function submitForm(f) {
    if (f.requestSubmit) {
      f.requestSubmit();
    } else {
      f.submit();
    }
  }

  function updateUrl() {
    var data = new FormData(form);
    var params = new URLSearchParams(data);
    var entries = Array.from(params.entries());
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i][1]) params.delete(entries[i][0]);
    }
    var url = params.toString() ? form.action + "?" + params.toString() : form.action;
    history.replaceState({}, "", url);
  }
});
